import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function analysisMethodList(
  account_id: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/analysis/method/list${queryString}`,
  );
}

export async function analysisMethodCreate(
  account_id: string,
  payload: {
    evaluation_id: string;
    analysis_id: string;
    group_id: string;
    method_id: string;
  },
) {
  return await clientAxios.post(
    `account/${account_id}/analysis/method/create`,
    payload,
  );
}

export async function analysisMethodDelete(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/analysis/method/${item_id}/delete`,
  );
}
